import moment from "moment";

export default {
  // Walidacja PESEL taka sama jak w Opiece w Terenie i w backendzie DOD/POD:
  // 11 cyfr + suma kontrolna na wagach [1,3,7,9,...]. Pusty PESEL przechodzi -
  // "pole wymagane" jest osobną regułą formularza.
  isValidPesel: function(pesel) {
    if (!pesel) {
      return true;
    }
    if (!/^\d{11}$/.test(pesel)) {
      return false;
    }
    const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
    const checksum = pesel
      .slice(0, 10)
      .split("")
      .reduce((sum, digit, index) => sum + parseInt(digit) * weights[index], 0);
    const controlDigit = (10 - (checksum % 10)) % 10;
    return controlDigit === parseInt(pesel[10]);
  },

  // UTC instant from the API -> "DD.MM.YYYY HH:mm" in Polish time, independent of the browser's zone.
  formattedWarsawDateTime: function(value) {
    if (!value) return "";
    const parts = {};
    new Intl.DateTimeFormat("pl-PL", {
      timeZone: "Europe/Warsaw",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    })
      .formatToParts(new Date(value))
      .forEach((part) => (parts[part.type] = part.value));
    return `${parts.day}.${parts.month}.${parts.year} ${parts.hour}:${parts.minute}`;
  },

  isHealthFeature: function(profile, feature) {
    const definition = (profile.available_profile_features || []).find(
      (f) => f.id === feature.main_value
    );
    return !!definition && definition.category === "HEALTH";
  },

  healthConsentLabel: function(profile) {
    if (!profile.health_data_consent_date) return "Brak";
    const status = profile.health_data_consent ? "Udzielona" : "Wycofana";
    return `${status}, dnia ${this.formattedWarsawDateTime(
      profile.health_data_consent_date
    )}`;
  },

  formattedDate: function(date) {
    moment.locale("pl");
    return moment(date).format("MMMM Do YYYY, HH:mm:ss");
  },

  formattedDateAsNumbers: function(date) {
    moment.locale("pl");
    return moment(date).format("YYYY-MM-DD, HH:mm");
  },
  formattedDateWithoutTime: function(date) {
    moment.locale("pl");
    if (!date) {
      return "";
    }
    return moment(date).format("DD MMMM YYYY");
  },
  dateWithoutTimeToString: function(date) {
    moment.locale("pl");
    return moment(date).format("YYYY-MM-DD");
  },
  dateToDayMonthYearFormat: function(date) {
    moment.locale("pl");
    return moment(date).format("DD-MM-YYYY");
  },
  dateToDayMonthYearFormatUTCOffset0: function(date) {
    moment.locale("pl");
    return moment(date)
      .utcOffset("+0000")
      .format("DD-MM-YYYY");
  },

  formattedDateForUsersActivityReport: function(startDate, endDate) {
    return (
      startDate.toString.substring(0, 10) +
      " - " +
      endDate.toString.substring(0, 10)
    );
  },
  formattedDateToStringWithTime: function(date) {
    moment.locale("pl");
    return moment(date).format("YYYY-MM-DD HH:mm:ss");
  },

  startOfDayFromTimestampDate: function(date) {
    moment.locale("pl");
    return moment(date)
      .startOf("day")
      .toString();
  },
  endOfDayFromTimestampDate: function(date) {
    moment.locale("pl");
    return moment(date)
      .endOf("day")
      .toString();
  },
  isToday: function(date) {
    return moment(date).isSame(moment(), "day");
  },
  isFuture: function(date) {
    return moment(date).isAfter(moment(), "day");
  },
  formattedDateToString: function(date) {
    moment.locale("pl");
    return moment(date).format("LLL");
  },
  formattedDateWithoutTimeToString: function(date) {
    moment.locale("pl");
    return moment(date).format("LL");
  },
  formatPhoneNumber: function(phoneNumber) {
    if (phoneNumber) {
      return phoneNumber.replaceAll("-", "").replace(/\s/g, "");
    } else {
      return "";
    }
  },
  getRechargeName: function(name) {
    if (name === "ACCOUNT") {
      return "Doładowanie konta";
    }
    if (name === "BONUS") {
      return "Doładowanie bonusowe";
    }
  },

  getPolishMonthNameByMonthNumber(monthNumber) {
    // 0 = January
    const months = {
      0: "Styczeń",
      1: "Luty",
      2: "Marzec",
      3: "Kwiecień",
      4: "Maj",
      5: "Czerwiec",
      6: "Lipiec",
      7: "Sierpień",
      8: "Wrzesień",
      9: "Październik",
      10: "Listopad",
      11: "Grudzień",
    };

    return months[monthNumber];
  },

  getPolishMonthNameByStringMonthNumber(monthNumber) {
    // 0 = January
    const months = {
      "01": "Styczeń",
      "02": "Luty",
      "03": "Marzec",
      "04": "Kwiecień",
      "05": "Maj",
      "06": "Czerwiec",
      "07": "Lipiec",
      "08": "Sierpień",
      "09": "Wrzesień",
      "10": "Październik",
      "11": "Listopad",
      "12": "Grudzień",
    };

    return months[monthNumber];
  },
};
